import {ErrorResponse, SessionErrorResponse} from "../types/StudioAPITypes";
import {LogLevel, RequestOptions} from "../types/Types";
import {DEFAULT_REQUEST_OPTIONS} from "../utils/constants";

export const POST_SESSION_BASE = 'POST_SESSION';
export const POST_SESSION_BEGIN   = `${POST_SESSION_BASE}_BEGIN`;
export const POST_SESSION_SUCCESS = `${POST_SESSION_BASE}_SUCCESS`;
export const POST_SESSION_FAILURE = `${POST_SESSION_BASE}_FAILURE`;
export const DELETE_SESSION_BASE = `DELETE_SESSION`;
export const DELETE_SESSION_BEGIN = `${DELETE_SESSION_BASE}_BEGIN`;
export const DELETE_SESSION_SUCCESS = `${DELETE_SESSION_BASE}_SUCCESS`;
export const DELETE_SESSION_FAILURE = `${DELETE_SESSION_BASE}_FAILURE`;
export const FETCH_SESSION_BASE = 'FETCH_SESSION';
export const FETCH_SESSION_BEGIN = `${FETCH_SESSION_BASE}_BEGIN`;
export const FETCH_SESSION_SUCCESS = `${FETCH_SESSION_BASE}_SUCCESS`;
export const FETCH_SESSION_FAILURE = `${FETCH_SESSION_BASE}_FAILURE`;
export const UPDATE_LOGIN_MESSAGE = 'UPDATE_LOGIN_MESSAGE';
export const UPDATE_RECAPTCHA_ID = 'UPDATE_RECAPTCHA_ID';
export const SET_TARGET_URL = 'SET_TARGET_URL';
export const SHOW_2FA_SETUP_DIALOG = 'SHOW_2FA_SETUP_DIALOG';
export const DISMISS_2FA_SETUP_DIALOG = 'DISMISS_2FA_SETUP_DIALOG';

export const RESET_SUBMIT_STATE = 'RESET_SUBMIT_STATE';
export const resetSubmitState = () => ({ type: RESET_SUBMIT_STATE });

export const SET_OTP_TOKEN = 'SET_OTP_TOKEN';
export const setOtpToken = (otpToken: string | null) => ({
  type: SET_OTP_TOKEN,
  otpToken
});

export const POST_OTP_BASE = 'POST_OTP';
export const POST_OTP_BEGIN   = `${POST_OTP_BASE}_BEGIN`;
export const POST_OTP_SUCCESS = `${POST_OTP_BASE}_SUCCESS`;
export const POST_OTP_FAILURE = `${POST_OTP_BASE}_FAILURE`;

export const postSessionBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: POST_SESSION_BEGIN,
  options: options
});

export const postSessionSuccess = (session: any) => ({
  type: POST_SESSION_SUCCESS,
  payload: { session }
});

export const postSessionError = (error: SessionErrorResponse, failedAttempts: number, showRecaptcha: boolean) => ({
  type: POST_SESSION_FAILURE,
  payload: { error },
  failedAttempts: failedAttempts,
  showRecaptcha: showRecaptcha
});

export const deleteSessionBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: DELETE_SESSION_BEGIN,
  options: options
});

export const deleteSessionSuccess = () => ({
  type: DELETE_SESSION_SUCCESS
});

export const deleteSessionFailure = (error: ErrorResponse) => ({
  type: DELETE_SESSION_FAILURE,
  payload: { error }
});

export const fetchSessionBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: FETCH_SESSION_BEGIN,
  options: options
});

export const fetchSessionSuccess = (session: any) => ({
  type: FETCH_SESSION_SUCCESS,
  payload: { session }
});

export const fetchSessionFailure = (error: ErrorResponse) => ({
  type: FETCH_SESSION_FAILURE,
  payload: { error }
});

export const updateMessage = (messageText: string, messageLevel: LogLevel) => ({
  type: UPDATE_LOGIN_MESSAGE,
  message: {
    text: messageText,
    level: messageLevel
  }
});

export const clearMessage = () => ({
  type: UPDATE_LOGIN_MESSAGE,
  message: null
});

export const updateRecaptchaId = (id: number) => ({
  type: UPDATE_RECAPTCHA_ID,
  id: id
})

export const setTargetUrl = (targetUrl: string) => ({
  type: SET_TARGET_URL,
  payload: { targetUrl }
})

export const showTwoFaSetupDialog = (setupUrl: string) => ({
  type: SHOW_2FA_SETUP_DIALOG,
  setupUrl
});

export const dismissTwoFaSetupDialog = () => ({
  type: DISMISS_2FA_SETUP_DIALOG
});

export const postOtpBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: POST_OTP_BEGIN,
  options
});

export const postOtpSuccess = () => ({
  type: POST_OTP_SUCCESS
});

export const postOtpFailure = (error: ErrorResponse) => ({
  type: POST_OTP_FAILURE,
  payload: { error }
});
